// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OnboardingPage_container__ShiIv {
  padding: 24px 16px;
  max-width: 500px;
  margin: 0 auto;
  color: white;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

h2 {
  font-size: 24px;
  margin-bottom: 12px;
  text-align: center;
}

p {
  font-size: 14px;
  text-align: center;
  color: #cccccc;
  margin-bottom: 24px;
}

.OnboardingPage_progress-indicators__is7OW {
  display: flex;
  justify-content: space-between; /* равномерно распределить */
  gap: 10px;
  align-items: center;
  width: 100%;
  margin: 0 auto 32px auto; /* центрирование и отступ вниз */
}

.OnboardingPage_progress-dot__HhOac {
  height: 6px;
  width: 110px; /* укороченные отрезки */
  border-radius: 999px;
  background-color: rgba(255, 255, 255, 0.15);
  transition: background-color 0.3s ease;
}

.OnboardingPage_progress-dot__HhOac.OnboardingPage_active__L-uYn {
  background: linear-gradient(90deg, #a66cff, #7851ff);
}

.OnboardingPage_step-content__0EJkz {
  background: rgba(255, 255, 255, 0.04);
  padding: 24px;
  border-radius: 16px;
  backdrop-filter: blur(8px);
  box-shadow: 0 0 20px rgba(140, 100, 255, 0.1);
}

.OnboardingPage_radio-group__-N0nq label {
  display: block;
  padding: 8px 12px;
  background-color: rgba(255, 255, 255, 0.06);
  border-radius: 12px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: background 0.2s;
}

.OnboardingPage_radio-group__-N0nq input[type="radio"] {
  accent-color: #a66cff; /* Фиолетовый акцент, в стиле прогресс-бара */
  margin-right: 10px;
}

.OnboardingPage_radio-group__-N0nq label:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.OnboardingPage_button-row__DVySF {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
}

.OnboardingPage_button-row__DVySF.OnboardingPage_two-buttons__aVjii {
  justify-content: space-between;
}

.OnboardingPage_fieldGroup__1XRzb {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.OnboardingPage_timeField__IpJj2 {
  display: flex;
  align-items: flex-start;
}

.OnboardingPage_suggestionList__jfbW9 {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 9999;
  background: linear-gradient(135deg, #5b2a85, #3b0a60);
  max-height: 200px;
  overflow-y: auto;
  list-style: none;
  padding: 10px 0;
  border-radius: 16px;
  box-shadow: 0 0 12px rgba(143, 100, 200, 0.35), 0 4px 18px rgba(100, 50, 170, 0.3),
    inset 0 0 6px rgba(200, 150, 255, 0.08);
  transition: all 0.2s ease;
}

.OnboardingPage_suggestionItem__o17wO {
  padding: 8px 12px;
  cursor: pointer;
}

.OnboardingPage_suggestionItem__o17wO:hover {
  background: rgba(255, 255, 255, 0.04);
}

/* @media (max-width: 768px) {
  .suggestionList.mobileFixed {
    position: fixed;
    left: 16px;
    right: 16px;
    bottom: 0;
    margin-bottom: env(safe-area-inset-bottom);
    max-height: 40vh;
    overflow-y: auto;
    z-index: 999;
    border-radius: 16px 16px 0 0;
  }
} */

.OnboardingPage_highlight__Fw3M5 {
  box-shadow: 0 0 20px rgba(166, 108, 255, 0.7), 0 0 30px rgba(120, 60, 255, 0.5);
  transition: box-shadow 0.3s ease;
}

.OnboardingPage_errorText__BUoG\\+ {
  color: #d48fff;
  font-size: 12px;
  line-height: 1.5;
  margin-top: -7px;
  margin-bottom: 5px;
  padding-left: 4px;
  min-height: 18px;
}

.OnboardingPage_invalid__pr\\+vT {
  border-color: #d48fff;
}
`, "",{"version":3,"sources":["webpack://./src/pages/OnboardingPage/OnboardingPage.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B,EAAE,4BAA4B;EAC5D,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,wBAAwB,EAAE,gCAAgC;AAC5D;;AAEA;EACE,WAAW;EACX,YAAY,EAAE,wBAAwB;EACtC,oBAAoB;EACpB,2CAA2C;EAC3C,sCAAsC;AACxC;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB,EAAE,6CAA6C;EACpE,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,qDAAqD;EACrD,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB;2CACyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;;;;;;;;;;;GAYG;;AAEH;EACE,+EAA+E;EAC/E,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[".container {\n  padding: 24px 16px;\n  max-width: 500px;\n  margin: 0 auto;\n  color: white;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\nh2 {\n  font-size: 24px;\n  margin-bottom: 12px;\n  text-align: center;\n}\n\np {\n  font-size: 14px;\n  text-align: center;\n  color: #cccccc;\n  margin-bottom: 24px;\n}\n\n.progress-indicators {\n  display: flex;\n  justify-content: space-between; /* равномерно распределить */\n  gap: 10px;\n  align-items: center;\n  width: 100%;\n  margin: 0 auto 32px auto; /* центрирование и отступ вниз */\n}\n\n.progress-dot {\n  height: 6px;\n  width: 110px; /* укороченные отрезки */\n  border-radius: 999px;\n  background-color: rgba(255, 255, 255, 0.15);\n  transition: background-color 0.3s ease;\n}\n\n.progress-dot.active {\n  background: linear-gradient(90deg, #a66cff, #7851ff);\n}\n\n.step-content {\n  background: rgba(255, 255, 255, 0.04);\n  padding: 24px;\n  border-radius: 16px;\n  backdrop-filter: blur(8px);\n  box-shadow: 0 0 20px rgba(140, 100, 255, 0.1);\n}\n\n.radio-group label {\n  display: block;\n  padding: 8px 12px;\n  background-color: rgba(255, 255, 255, 0.06);\n  border-radius: 12px;\n  margin-bottom: 8px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.radio-group input[type=\"radio\"] {\n  accent-color: #a66cff; /* Фиолетовый акцент, в стиле прогресс-бара */\n  margin-right: 10px;\n}\n\n.radio-group label:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.button-row {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n.button-row.two-buttons {\n  justify-content: space-between;\n}\n\n.fieldGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.timeField {\n  display: flex;\n  align-items: flex-start;\n}\n\n.suggestionList {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  z-index: 9999;\n  background: linear-gradient(135deg, #5b2a85, #3b0a60);\n  max-height: 200px;\n  overflow-y: auto;\n  list-style: none;\n  padding: 10px 0;\n  border-radius: 16px;\n  box-shadow: 0 0 12px rgba(143, 100, 200, 0.35), 0 4px 18px rgba(100, 50, 170, 0.3),\n    inset 0 0 6px rgba(200, 150, 255, 0.08);\n  transition: all 0.2s ease;\n}\n\n.suggestionItem {\n  padding: 8px 12px;\n  cursor: pointer;\n}\n\n.suggestionItem:hover {\n  background: rgba(255, 255, 255, 0.04);\n}\n\n/* @media (max-width: 768px) {\n  .suggestionList.mobileFixed {\n    position: fixed;\n    left: 16px;\n    right: 16px;\n    bottom: 0;\n    margin-bottom: env(safe-area-inset-bottom);\n    max-height: 40vh;\n    overflow-y: auto;\n    z-index: 999;\n    border-radius: 16px 16px 0 0;\n  }\n} */\n\n.highlight {\n  box-shadow: 0 0 20px rgba(166, 108, 255, 0.7), 0 0 30px rgba(120, 60, 255, 0.5);\n  transition: box-shadow 0.3s ease;\n}\n\n.errorText {\n  color: #d48fff;\n  font-size: 12px;\n  line-height: 1.5;\n  margin-top: -7px;\n  margin-bottom: 5px;\n  padding-left: 4px;\n  min-height: 18px;\n}\n\n.invalid {\n  border-color: #d48fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `OnboardingPage_container__ShiIv`,
	"progress-indicators": `OnboardingPage_progress-indicators__is7OW`,
	"progress-dot": `OnboardingPage_progress-dot__HhOac`,
	"active": `OnboardingPage_active__L-uYn`,
	"step-content": `OnboardingPage_step-content__0EJkz`,
	"radio-group": `OnboardingPage_radio-group__-N0nq`,
	"button-row": `OnboardingPage_button-row__DVySF`,
	"two-buttons": `OnboardingPage_two-buttons__aVjii`,
	"fieldGroup": `OnboardingPage_fieldGroup__1XRzb`,
	"timeField": `OnboardingPage_timeField__IpJj2`,
	"suggestionList": `OnboardingPage_suggestionList__jfbW9`,
	"suggestionItem": `OnboardingPage_suggestionItem__o17wO`,
	"highlight": `OnboardingPage_highlight__Fw3M5`,
	"errorText": `OnboardingPage_errorText__BUoG+`,
	"invalid": `OnboardingPage_invalid__pr+vT`
};
export default ___CSS_LOADER_EXPORT___;
